module.exports = __webpack_public_path__ + "static/media/ui_ux_design 2.74c0decb.svg";